"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firestoreTimestampDeserialize = void 0;
const deserializeNumber_1 = require("../deserializeNumber");
const deserializeObject_1 = __importDefault(require("../deserializeObject"));
function firestoreTimestampDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        nanoseconds: (0, deserializeNumber_1.deserializeNumber)(object.nanoseconds, 0),
        seconds: (0, deserializeNumber_1.deserializeNumber)(object.seconds, 0),
    };
}
exports.firestoreTimestampDeserialize = firestoreTimestampDeserialize;
